import { ApolloLink, FetchResult, NextLink, Observable, Operation } from '@apollo/client';
import { ITokenService } from './TokenService';
import { ISessionService } from './SessionService';

class RefreshTokenLink extends ApolloLink {
    #tokenService: ITokenService;
    #sessionService: ISessionService;

    constructor(tokenService: ITokenService, sessionService: ISessionService) {
        super();
        this.#tokenService = tokenService;
        this.#sessionService = sessionService;
    }

    request(operation: Operation, forward: NextLink): Observable<FetchResult> {
        return new Observable((observer) => {
            // async IIFE to handle async token refresh looks more readable for now
            (async () => {
                try {
                    await this.#tokenService.refreshToken();

                    // Subscribe to the forwarded operation and run chain after token refresh
                    const forwarded = forward(operation);
                    forwarded.subscribe({
                        next: (result) => observer.next(result),
                        error: (error) => observer.error(error),
                        complete: () => observer.complete(),
                    });
                } catch (error) {
                    this.#sessionService.logoff();
                    observer.error(error);
                }
            })();
        });
    }
}

export default RefreshTokenLink;
